import { Button, Box, Typography, useTheme } from '@mui/material'
function LoginPage() {
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'
  const url =
    window.location.pathname + window.location.search + window.location.hash
  console.log(url)
  const handleLogin = () => {
    // must use href not pathname so the query string isn't percent-encoded as a literal path
    window.location.href = `/oauth2/start?provider=microsoft&rd=${encodeURIComponent(url)}`
  }
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      width="100vw"
      bgcolor={isDark ? '#2a2a2e' : '#f5f5f5'}
    >
      <Typography variant="h4" gutterBottom>
        Welcome to the Application
      </Typography>
      <Typography variant="body1" gutterBottom>
        Please log in to continue
      </Typography>
      <Button
        variant="contained"
        startIcon={
          <img
            src="/ms.ico"
            alt="Microsoft Logo"
            style={{ width: 20, height: 20 }}
          />
        }
        onClick={handleLogin}
        sx={{
          bgcolor: isDark ? '#4da3e8' : '#0078d4',
          color: '#fff',
          '&:hover': {
            bgcolor: isDark ? '#2e8fd6' : '#005a9e',
          },
          padding: '10px 20px',
          textTransform: 'none',
        }}
      >
        Sign in with Microsoft
      </Button>
    </Box>
  )
}

export default LoginPage
